<template>
  <div style="height: 100%;">
    <version1 v-if="version === '1'"></version1>
    <version2 v-if="version === '2'"></version2>
    <version-ciicshared v-if="version === '3'"></version-ciicshared>
    <version-v2 v-if="version === 'v2'"></version-v2>
  </div>
</template>

<script>
import version1 from '../index/index.vue'
import version2 from '../index2/index.vue'
import versionCiicshared from '../CIICSharedHRConsultancy/index.vue'
// 薪税云2.0
import versionV2 from '../index-v2/index.vue'
import { mapGetters } from 'vuex';

export default {
  name: 'codelogin',
  components: {version1, version2, versionCiicshared, versionV2},
  data() {
    return {
      version: ''
    }
  },
  created() {
    if (this.$route.query.sign && this.$route.query.userid) {
      this.version = 3;
      localStorage.setItem('version', 3);
      this.$store.commit('SET_ISYGJ', true);
    } else {
      this.version = localStorage.getItem('version');
      this.$store.commit('SET_ISYGJ', false);
    }
    if (!this.cusListTotal || !this.cusListTotal.length) {
      this.$store.dispatch('getCusListTotal');
    }
  },
  computed: {
    ...mapGetters(['cusListTotal'])
  }
}
</script>

<style scoped>
	.version-wrapper {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
</style>


